const IHashingServiceId = Symbol("IHashingService");

interface IHashingService {
    createHash(data:string);
}

export { IHashingServiceId, IHashingService }